import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import pipeline from "../assets/images/azurepipelines-svgrepo-com.svg"
import Header from "./Header";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LoadingModal from "./LoadingModal";

export default function Manager() {
  const { instance } = useMsal();
  const [pipelines, setPipelines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [embedToken, setEmbedToken] = useState(null);
  const [selectedPipelines, setSelectedPipelines] = useState([]);
  const [selectedPipelinesFabric, setSelectedPipelinesFabric] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkspaceName, setSelectedWorkspaceName] = useState("");
  const workspaceId = "458caa09-dc22-4c46-b208-cbd4c3421d8a";

  
  const servidor = "https://analytics.centenario.com.pe";
  //const servidor = "http://localhost:3000";
  const intervalRef = useRef(null);

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  };

  const userAuth = getAccountInfo();

  const user = {
    name: userAuth?.name || "Usuario desconocido",
    email: userAuth?.username || "email@desconocido.com",
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      //postLogoutRedirectUri: "http://localhost:3000",
      postLogoutRedirectUri: "https://analytics.centenario.com.pe", // Cambia esto según tu entorno
    });
  };

  const handleAddDatapipelines = () => {

    setShowModal(true);

  }

  const handleExecuteDataPipeline = async (pipelineId,name) => {

    try {
            await axios.post(`${servidor}/api/saveExecutePipelines`, {
                id: pipelineId,
                user: user.email,
                displayName: name,
            });
        } catch (error) {
            console.error("Error ejecutando el pipeline:", error);
        }finally{
          alert("Se lanzó la ejecución correctamente.");
          window.location.reload();
        }
  }

    // Obtener datos desde API
    const fetchData = async () => {
      try {
        const [pipelinesRes] = await Promise.all([
          axios.get(`${servidor}/api/pipelines`),
        ]);
  
        setPipelines(pipelinesRes.data);

        setLoading(false);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

     const startInterval = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          if (document.visibilityState === "visible") {
            fetchData();
          }
        }, 60000); // 60 segundos
      }
    };

      const clear = () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };


    useEffect(() => {
    // Llamada inicial
      if(pipelines.length === 0)
      {
        fetchData();
      }

      // Arrancar intervalo solo cuando la página está visible
      if (document.visibilityState === "visible") {
        startInterval();
      }

      const handleVisibility = () => {
        if (document.visibilityState === "visible") {
          startInterval();
        } else {
          clear();
        }
      };

      document.addEventListener("visibilitychange", handleVisibility);

      // Cleanup al desmontar
      return () => {
        clear();
        document.removeEventListener("visibilitychange", handleVisibility);
      };
    
  }, []);

    useEffect(() => {
                const fetchToken = async () => {
                    if (!userAuth) {
                        //console.log("Usuario no autenticado, redirigiendo...");
                        await instance.loginPopup({
                            scopes: ["https://api.fabric.microsoft.com/.default"],
                        });
                    }
        
                    try {
                        const tokenResponse = await instance.acquireTokenSilent({
                            scopes: ["https://api.fabric.microsoft.com/.default"],
                            account: userAuth,
                        });
                        //console.log("TokenCliente:", tokenResponse.accessToken);
                        setEmbedToken(tokenResponse.accessToken);
                    } catch (error) {
                        console.error("Error al obtener el token:", error);
                    }
                };
        
                fetchToken();
            }, [instance, userAuth,embedToken]);

    useEffect(() => {
      
      try {
            const fetchDataPipelines = async () => {

            const response = await axios.get(
                  `https://api.fabric.microsoft.com/v1/workspaces/${workspaceId}/dataPipelines`,
                  {
                    headers: {
                      Authorization: `Bearer ${embedToken}`,
                    },
                  }
                );
          
          const Datapipelines = response.data.value
          const pipelinesActivos = pipelines;

          // Crear set de IDs activos para búsqueda rápida
          const activosSet = new Set(pipelinesActivos.map(r => r.PipelineId.trim()));

          const reportesCombinados = Datapipelines.map((rep) => {
          const isActive = activosSet.has(rep.id.trim());;
          
          return {
            ...rep,
            activo: isActive,
          };
          });
            
          setSelectedPipelinesFabric(reportesCombinados);

          }

          if (embedToken) {
              fetchDataPipelines();
            }
      } catch (error) {
        console.error("Error fetching workspaces:", error);
      }

    },[embedToken,pipelines]);

  return (
    <div><Header user={user} onLogout={handleLogout} />
    <LoadingModal isOpen={loading} />
    <div className="container">
      <div className="row">
        <div className="col-6">
          <h2>
              <img 
                src={pipeline} 
                alt="Azure Pipelines Icon" 
                style={{ width: "30px", verticalAlign: "middle", marginRight: "8px" }} 
              />
              Pipelines de Fabric
            </h2>
        </div>
        <div className="col-6" style={{textAlign:"left",margin:"10px"}}>
        <a style={{cursor:"pointer"}} onClick={() => handleAddDatapipelines()}>+ Agregar DataPipelines</a>
        </div>
        
      </div>
        <div className="row">
          <div className="col-12">
            
              {pipelines.length === 0 && <p>No se encontraron pipelines.</p>}
              <ul style={{ listStyle: "none", padding: 0 }}>
                {pipelines.map((pipeline) => (
                  <li
                    key={pipeline.PipelineId}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>{pipeline.Description}</span>
                    <button
                      disabled={pipeline.IsScheduled == 1?true:loading}
                      onClick={() => {
                        if (window.confirm("¿Deseas ejecutar este pipeline?")) 
                          {
                            handleExecuteDataPipeline(pipeline.PipelineId, pipeline.Description);
                          }
                      }
                      }
                      style={{
                        padding: "6px 12px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#0078d4",
                        color: "white",
                        cursor: "pointer",
                        width:"130px"
                      }}
                    >
                    {pipeline.IsScheduled == 1 ? "Ejecutando..." : "▶ Ejecutar"}
                    </button>
                  </li>
                ))}
              </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
          </div>
        </div>
      </div>


    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
      <Modal.Header closeButton>
        <h5 className="text-center" style={{fontFamily:"montserrat-extrabold", textAlign:"center", paddingTop:"10px"}}>
        {selectedWorkspaceName}
      </h5>
      </Modal.Header>
      <Modal.Body style={{overflowY:"auto", maxHeight:"70vh"}}>
        {selectedPipelinesFabric.length === 0 ? (
          <p style={{fontFamily:"montserrat-extrabold"}}>No hay DataPipelines disponibles.</p>
        ) : (
          <div className="list-group">
            {selectedPipelinesFabric.map((rep) => (
              <label key={rep.id} className="list-group-item-pipeline">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={rep.activo}
                 onChange={() => {
                    setSelectedPipelinesFabric((prev) =>
                        prev.map((r) =>
                          r.id === rep.id ? { ...r, activo: !r.activo } : r
                        )
                      );
                  }}
                />
                {rep.displayName.toUpperCase()}
              </label>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={async () => {
            setLoading(true);
            const pipelinesSeleccionados = selectedPipelinesFabric
                /*.filter((r) => r.activo)*/
                .map((r) => ({
                  id: r.id,
                  displayName: r.displayName,
                  workspaceId: r.workspaceId,
                  activo: r.activo,
                }));
            
            try {
              await axios.post(`${servidor}/api/saveSelectedPipelines`, {
                selectedPipelines: pipelinesSeleccionados,
            });
            } catch (error) {
              alert("Error inesperado, vuelva a intentarlo.");
            } finally{
              setLoading(false);
              setShowModal(false);
              alert("Selección guardada correctamente");
              window.location.reload();
            }
          }}
        >
          Guardar selección
        </Button>
      </Modal.Footer>
    </Modal>


    </div>
  );
}

const styless = `

.list-group-item-pipeline {
    color: #d32f2f;
    font-family: 'montserrat-extrabold';
    font-size: 12pt;
    transition: all 0.2s ease-in-out; /* suaviza el cambio */
    cursor:pointer;
}

.list-group-item-pipeline:hover,
.list-group-item-pipeline:active {
    color: #ffffff;
    background-color: #d32f2f;
}
`;

const styleTag = document.createElement("style");
styleTag.innerHTML = styless;
document.head.appendChild(styleTag);

